module.exports = __webpack_public_path__ + "img/logo.f3813c6c.jpg";